import { useFormik } from 'formik';
import { useEffect } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { GetAmeCondition } from '../../../../store/Ame/ameSlice';
import {
  GetAmeConditionUsageListByRuleId,
  cleanConditionUsageListByRuleId,
  insertAmeConditionUsage,
  DeleteAmeConditionUsage,
} from '../../../../store/Ame/ameConditionUsageSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Loading from '../../../../components/Shared/Loader/Loading';

import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import NoData from '../../../../components/NoData/NoData';

const AddAmeConditionUsage = ({ ruleId, onclose }) => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  //

  const { AmeConditionList } = useSelector((state) => state.Ame);
  useEffect(() => {
    dispatch(GetAmeCondition(id));
  }, [dispatch, id]);

  const { ConditionUsageListByRuleId, loading, error } = useSelector(
    (state) => state.AmeConditionUsage
  );
  useEffect(() => {
    dispatch(GetAmeConditionUsageListByRuleId(ruleId));

    return () => {
      dispatch(cleanConditionUsageListByRuleId());
    };
  }, [dispatch, ruleId]);

  const formik = useFormik({
    initialValues: {
      ruleId: ruleId,
      conditionId: '',
    },
    validationSchema: Yup.object().shape({
      conditionId: Yup.string().required(() => t('Required')),
    }),
    onSubmit: (values) => {
      const existingUsage = ConditionUsageListByRuleId?.find(
        (usage) => usage.conditionId === values.conditionId
      );

      if (existingUsage) {
        CustomAlert({ action: 'Error', msg: 'مضاف مسبقاً' });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        insertAmeConditionUsage({
          ruleId: ruleId,
          conditionId: formik.values.conditionId,
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          dispatch(GetAmeConditionUsageListByRuleId(ruleId));
        })
        .catch((error) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    },
  });

  //___________

  const handleDeleteConditionUsage = (item) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeleteAmeConditionUsage(item.id))
        .unwrap()
        .then(() => {
          dispatch(GetAmeConditionUsageListByRuleId(ruleId));
          CustomAlert({ action: 'Delete' });
        })
        .catch((error) => {
          CustomAlert({ action: 'Error' });
        });
    });
  };

  return (
    <>
      <Loading loading={loading} error={error} Type="Dots">
        <Form onSubmit={formik.handleSubmit}>
          <div className="row align-items-end">
            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label" htmlFor="exampleFormControlSelect1">
                  {t('Condition')}
                </label>
                <Form.Select
                  className="form-select"
                  name="conditionId"
                  onChange={formik.handleChange}
                  value={formik.values.conditionId}
                  isInvalid={!!formik.errors.conditionId}>
                  <option value={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {AmeConditionList?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {formik.errors.conditionId}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-6 text-end  ">
              <div className=" form-group mb-3 d-flex justify-content-end ">
                <button
                  disabled={formik.isSubmitting}
                  type="submit"
                  className="btn me-1 btn-theme   w-75">
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
                  )}
                  {t('Add')}
                </button>
                <button type="button" className=" btn me-1 btn-default  w-25" onClick={onclose}>
                  <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </div>
        </Form>

        {ConditionUsageListByRuleId?.length > 0 ? (
          <div className="table-responsive rounded-2 text-center ">
            <table className="table table-hover mb-0">
              <thead className="bg-theme bg-opacity-40">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"> {t('Condition')}</th>
                  <th scope="col"></th>
                </tr>
              </thead>

              <tbody>
                {ConditionUsageListByRuleId?.map((item, idx) => (
                  <tr key={item.id}>
                    <td className="align-middle">{++idx}</td>
                    <td className="align-middle">
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </td>

                    <td className="align-middle">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger btn-lg m-0"
                        onClick={() => handleDeleteConditionUsage(item)}>
                        <i className="fas fa-trash-alt fa-fw fa-lg"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <NoData message="لا توجد شروط لهذه القاعدة" />
        )}
      </Loading>
    </>
  );
};

export default AddAmeConditionUsage;
